import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgCallBackIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M15.3367 3.9395v4.6972m0 0h4.7194m-4.7194 0L21 3M10.8315 13.2054c-1.1342-1.1289-2.0298-2.4052-2.6867-3.767-.0565-.1172-.0848-.1758-.1065-.25-.0771-.2633-.0217-.5867.1388-.8098.0451-.0627.099-.1164.207-.2238.33-.3285.495-.4927.6028-.6578a1.872 1.872 0 0 0 0-2.0484c-.1078-.1651-.2728-.3293-.6028-.6578l-.184-.183c-.5016-.4993-.7524-.749-1.0218-.8845a1.896 1.896 0 0 0-1.704 0c-.2694.1356-.5203.3852-1.0219.8845l-.1488.148c-.4999.4976-.7498.7464-.9407 1.0846-.2119.3753-.3642.9583-.3629 1.3888.0012.3879.0768.653.228 1.1833.8127 2.8497 2.346 5.5388 4.6 7.7822s4.9558 3.7695 7.819 4.5784c.5328.1505.7992.2257 1.1889.2269.4326.0013 1.0182-.1503 1.3953-.3612.3399-.19.5898-.4387 1.0897-.9363l.1488-.1481c.5016-.4993.7524-.7489.8887-1.017a1.87 1.87 0 0 0 0-1.6961c-.1363-.2681-.3871-.5177-.8887-1.017l-.1839-.183c-.33-.3285-.495-.4927-.6609-.6001a1.895 1.895 0 0 0-2.0581 0c-.1659.1074-.3309.2716-.6609.6001-.1079.1073-.1618.161-.2249.206-.2241.1597-.549.2149-.8137.1381-.0744-.0216-.1333-.0497-.251-.106-1.3683-.6538-2.6507-1.5452-3.7848-2.674"
    />
  </svg>
);
export default SvgCallBackIcon;
